import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Typography,
  Form,
  Input,
  Alert,
  Card,
} from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { userService } from "../../services/userService";

import "./PasswordResetRequest.css";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const PasswordResetRequest = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await userService.requestPasswordReset(values.email);
      setSuccess(true);
      form.resetFields();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to send password reset email. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Layout className="layout-default layout-password-reset">
      <Content className="password-reset">
        <Card className="password-reset-card">
          <Title className="mb-15" level={2}>
            Reset Password
          </Title>
          <Paragraph className="text-muted mb-24">
            Enter your email address and we'll send you a link to reset your
            password.
          </Paragraph>

          {/* Success Message */}
          {success && (
            <Alert
              message="Email Sent!"
              description="If the email exists in our system, a password reset link has been sent. Please check your inbox."
              type="success"
              showIcon
              style={{ marginBottom: 24 }}
            />
          )}

          {/* Error Message */}
          {error && (
            <Alert
              message="Request Failed"
              description={error}
              type="error"
              showIcon
              style={{ marginBottom: 24 }}
            />
          )}

          <Form
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="password-reset-form"
            form={form}
          >
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please input your email address!",
                },
                {
                  type: "email",
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="your.email@example.com"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                size="large"
                loading={loading}
              >
                Send Reset Link
              </Button>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="link"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate("/sign-in")}
                style={{ padding: 0 }}
              >
                Back to Sign In
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default PasswordResetRequest;
